import { render, staticRenderFns } from "./CommonDetail.vue?vue&type=template&id=216b69d6&scoped=true"
import script from "./CommonDetail.vue?vue&type=script&lang=js"
export * from "./CommonDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b69d6",
  null
  
)

/* custom blocks */
import block0 from "@/components/Common/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FCommon%2FCommonDetail.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports